import { makeConfig } from './config.common';

const config = makeConfig({
  DOMAIN: 'grannysex.dating',
  TITLE: 'Granny Sex Dating ',
  NICHE: 'Granny',
  PROJECT: 'grannysexdating',
  NICHE_SINGULAR: 'Granny',
  NICHE_PLURAL: 'Granny',
  GENDER_OTHER: 3, // if this options is set that means that niche uses new gender
  GENDER_OTHER_VARIABLE_NAME: 'genderCouple', // use this as gender variable name in localization file
  /**
   * based on documentation https://docs.google.com/document/d/1Z1wBM-yFLC9c9WGCLtmNn0Vn7ig009zVdOSyLSKsbMI/edit#
   * gender -> seeking
   * gender is one of three integers (1, 2, & 3) not bitmask!!!!
   * seeking genders is bitmask based on:
   * 001 (int 1) -> male
   * 010 (int 2) -> female
   * 100 (int 4) -> other
   * So this can be used as
   * male -> female: 1 -> 2 i.e "1_2"
   * male -> other: 1 -> 4 i.e "1_4"
   * male -> female & other: 1 -> 6 (simple as binary addition) i.e "1_6"
   * so when creating visible options keep in mind that firs param is not binary and second is
   */
  GENDER_SEEKING_SIGNUP_LOGIN: {
    visibleOptions: ['1_2', '2_1'], // male -> Ts/Tv/Tg, female -> Ts/Tv/Tg
    moreOptions: ['1_4', '2_4', '3_1', '3_2', '3_4'], // Ts/Tv/Tg -> male, Ts/Tv/Tg -> female, Ts/Tv/Tg -> Ts/Tv/Tg
  },
  NEW_GENDER: 1,
  NEW_SEEKING: 2,
  GOOGLE_ID: 'UA-52125585-53',
  COMPANY_NAME: 'nearbycs.com',
  TYPE: 'adult',
  SENTRY_RELEASE: 'www-grannysex-dating',
  SENTRY_DNS:
    'https://79855ef818b8a47b68d32789f572c91f@sentry.nearbyapi.com/14',
  TABOOLA_TRACKING_PIXEL: '1730669',
});

export default config;



// WEBPACK FOOTER //
// ./src/constants/config.js